import Layout from './routes/Layout.js';

function App() {
  return (
    <>
      <Layout/>
    </>
  );
}

export default App;
